import * as React from 'react'
import * as PropTypes from 'prop-types'
import { css, Rule } from 'glamor'
import createStyles from './styles'
import { isKey } from '../../utils'
import { useTheme } from '../../theme'
import { UiVariant } from '../../types'

const levels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
const variants = [
  'regular',
  'dim',
  'white',
  'inherit',
  'primary',
  'secondary',
  'positive',
  'negative',
  'alert',
  'cta',
  'brand',
]

interface IHeadingProps {
  children?: React.ReactNode
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  variant?: 'regular' | 'dim' | 'white' | 'inherit' | UiVariant
  bold?: boolean
  flush?: boolean
  style?: Rule
}

/**
 * @type { React.StatelessComponent }
 */
export function Heading({ level, tag, variant, bold, flush, style, ...rest }: IHeadingProps) {
  const styles = createStyles(useTheme())
  // default to the tag for the level if not specified
  const Component = tag || level

  if (!Component) {
    return null
  }

  return (
    <Component
      {...css([
        styles.base,
        isKey(styles, level) && styles[level],
        isKey(styles.variants, variant) && styles.variants[variant],
        bold && styles.bold,
        flush && styles.flush,
        style,
      ])}
      {...rest}
    />
  )
}

Heading.propTypes = {
  children: PropTypes.node,
  level: PropTypes.oneOf(levels),
  tag: PropTypes.oneOf(levels),
  variant: PropTypes.oneOf(variants),
  bold: PropTypes.bool,
  flush: PropTypes.bool,
  style: PropTypes.object,
}

Heading.defaultProps = {
  level: 'h1',
  variant: 'inherit',
}

Heading.LEVELS = levels
Heading.VARIANTS = variants
